
        require('./index.scss');
        'use strict';

var _formCheck = require('../home-toutiao/formCheck');

var _formCheck2 = _interopRequireDefault(_formCheck);

var _home = require('model/service/home');

var _home2 = _interopRequireDefault(_home);

var _kftMd = require('assets/util/kft-md5');

var _kftMd2 = _interopRequireDefault(_kftMd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ = window.$;
var $mod = $('.module-design-free');
var citySelect = require('component/cityselect');


var secretKey = 'd4c38977656e2356a6837e7b771bd408';

var _module = {
    designCheck: {},
    mobileChange: false,
    init: function init() {
        this.blockShowHide();
        this.cardshow();
        this.typeChange();
        this.claseClick();
        this.listener();
        citySelect($mod.find('.city-select'));
        this.formSubmit();
        this.placeHolder();
        this.areaInput();
        var that = this;
        $mod.find('.mobile-input-block').change(function (e) {
            if (e.target.value !== window.mobile) {
                that.mobileChange = true;
            } else {
                that.mobileChange = false;
            }
        });
    },
    areaInput: function areaInput() {
        $('.form-container .area-data-block').on('input', function (_ref) {
            var target = _ref.target;

            $(target).val($(target).val().replace(/[^\d]/g, ''));
        });
    },
    blockShowHide: function blockShowHide() {
        $mod.find('.close').click(function () {
            $mod.hide();
        });
        $mod.click(function (e) {
            if ($(e.target).closest('.info-container').length <= 0 && $(e.target).closest('.success-container').length <= 0) {
                $mod.hide();
            }
        });
    },
    placeHolder: function placeHolder() {
        $mod.find('.palceinfo').each(function (index, item) {
            $(item).addClass('grey').val($(this).data('placeholder'));
        });
        $mod.find('.palceinfo').focus(function () {
            if ($(this).val() == $(this).data('placeholder')) {
                $(this).val('').removeClass('grey');
            }
        }).blur(function () {
            if (!$(this).val()) {
                $(this).addClass('grey').val($(this).data('placeholder'));
            }
        });
    },
    cardshow: function cardshow() {
        var that = this;
        $mod.find('.has-card').click(function (e) {
            var $showHide = $(e.target).closest('.show-hide-block');
            if ($showHide.length >= 1) {
                return;
            }
            $mod.find('.show-hide-block').not($(this).find('.show-hide-block')).removeClass('show').prev().removeClass('open');
            $(this).find('.show-hide-block').toggleClass('show').prev().toggleClass('open');
            if ($(this).hasClass('huxing')) {
                that.huxingParse.call(that);
            }
        });

        $(window).click(function (e) {
            var $card = $(e.target).closest('.has-card');
            if ($card.length > 0) {
                return;
            }
            $mod.find('.show-hide-block').removeClass('show').prev().removeClass('open');
        });
    },
    typeChange: function typeChange() {
        $mod.find('.type .select-line').click(function () {
            var text = $(this).text();
            $mod.find('.type .text-info').text(text);
            $mod.find('.type .show-hide-block').removeClass('show').prev().removeClass('open');
        });
    },
    claseClick: function claseClick() {
        $mod.find('.clause .check').click(function () {
            $(this).toggleClass('active');
        });
    },
    listener: function listener() {
        Event.on('design-success-show', function () {
            $mod.find('.info-container').hide();
            $mod.find('.success-container').show();
            $mod.show();
        });
        Event.on('design-block-show', function () {
            $mod.find('.info-container').show();
            $mod.find('.success-container').hide();
            $mod.show();
        });
    },
    formSubmit: function formSubmit() {
        var _this = this;

        this.designCheck = new _formCheck2['default']($mod, [{
            name: 'name',
            container: '.form-container .name-input-block'
        }, {
            name: 'mobile',
            container: '.form-container .mobile-input-block'
        }, {
            name: 'city',
            container: '.form-container .city-select'
        }, {
            name: 'area',
            container: '.form-container .area-data-block'
        }, {
            name: 'clause',
            container: '.form-container .clause-data-block'
        }]);
        $mod.find('.form-container .sub-button').click(function (e) {
            var res = _this.designCheck.check();
            if (_this.mobileChange && !window.captcha && res) {
                if (window.verify) {
                    var mobile = $mod.find('.mobile-input-block').val();
                    window.verify(mobile, $(e.target));
                }
            } else if (res) {
                console.log(res);
                var d = new Date();
                var data = {
                    adCode: res.areaCode,
                    name: res.name + '-' + res.area + '\u33A1',
                    tel: res.mobile,
                    logDesc: 2,
                    eventTime: d.toISOString().slice(0, 10) + ' ' + /\d{2}:\d{2}:\d{2}/.exec(d)[0],
                    sign: (0, _kftMd2['default'])(res.mobile + secretKey),
                    captcha: window.captcha || ''
                };
                _home2['default'].postClue(data).then(function (result) {
                    if (result.code === 200) {
                        Event.trigger('design-success-show');
                        if (!window.mobile) setTimeout(function () {
                            return window.location.reload();
                        }, 5000);
                        // Home.postDesign(res).then((response)=> {
                        //     if (response.code === 0) {
                        //         Event.trigger('design-success-show');
                        //         if (!window.mobile) setTimeout(()=> window.location.reload(), 5000);
                        //     }
                        // },(err) => {
                        //     console.log(err)
                        // });
                    } else {
                        window.toast && window.toast(result.msg || '提交失败，请稍后重试', 5000);
                    }
                    window.captcha = null;
                });
            }
        });
    }
};

_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/home-index/design-free/index.js